// "Active" ledger rows are the ones still open: the same families the server's
// lifecycle guard treats as blockers, minus settled money (cleared receipts).
const CLOSED_RECEIPT = new Set(['cleared', 'rejected', 'reversed', 'withdrawn']);
const CLOSED_CHEQUE = new Set(['cancelled', 'returned', 'bounced', 'replaced', 'cleared']);
const CLOSED_ARRANGEMENT = new Set(['cancelled', 'superseded', 'settled']);
const OPEN_CHANGE_REQUEST = new Set(['pending', 'requested', 'pending_review', 'pending_approval']);
const CLOSED_REFUND = new Set(['cancelled', 'paid']);
const OPEN_REVISION = new Set(['pending_customer', 'pending_approval']);
const OPEN_LINK = new Set(['creating', 'active', 'cancellation_pending']);

export function isActiveLedgerRow(row) {
  const status = row?.status;
  if (!status) return false;
  switch (row.kind) {
    case 'intent': return OPEN_LINK.has(status) && row.detail?.effective_status !== 'expired';
    case 'receipt': return !CLOSED_RECEIPT.has(status);
    case 'cheque': return !CLOSED_CHEQUE.has(status);
    case 'arrangement': return !CLOSED_ARRANGEMENT.has(status);
    case 'settlement_change': return OPEN_CHANGE_REQUEST.has(status);
    case 'refund': return !CLOSED_REFUND.has(status);
    case 'revision': return OPEN_REVISION.has(status);
    default: return false;
  }
}

export const activeLedgerRows = rows => (rows || []).filter(isActiveLedgerRow);
